import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
export function useL10n() {
    const { t } = useTranslation();
    const l10n = useMemo(() => ({
        /**
         * Buttons
         */
        apply: t('general.apply'),
        cancel: t('general.cancel')
    }), [t]);
    return { l10n };
}
